<template>
    <div>
      <div>
        <div class="main-wrapper">
          <div>
            <!-- <layout-header2></layout-header2> -->
            <layout-header></layout-header>
            <breadcrumb62></breadcrumb62>
            <!-- Page Content -->
            <div class="content">
              <div class="container">
                <div class="row">
                  <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                    <sidebar2></sidebar2>
                  </div>
  
                  <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                    <loader></loader>
                  </div>
  
                  <div class="col-md-7 col-lg-8 col-xl-9" v-else>
                    <div class="ml-md-4">
                      <div class="container p-3" style="background-color:#f8f8f8;">
                        <div>
                        <p style="font-size:20px;color:black;">Training Videos</p>
                      </div>
                        <div class="row">
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">1</span>
                          <img src="@/assets/img/Patient_Appointment_Schedule.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Patient Appointment Schedule</h4>
          <p class="card-description" style="height:150px;">Streamlined Hospital Patient Appointment Management for Excellence.</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1"  @click="openVideoPopup(0)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">2</span>
                          <img src="@/assets/img/Hospital's_Affiliated_Doctors.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Hospital's Affiliated Doctors</h4>
          <p class="card-description"  style="height:150px;">List of Your Trusted Doctors for Optimal Healthcare Solutions.</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1"  @click="openVideoPopup(1)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">3</span>
                          <img src="@/assets/img/Patient_List_in_Hospitals.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Patient List in Hospitals</h4>
          <p class="card-description"  style="height:150px;">Tracking and Managing Patient Information Efficiently.</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1" @click="openVideoPopup(2)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">4</span>
                          <img src="@/assets/img/Patient_Encounter_History_Management.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Patient Encounter History Management</h4>
          <p class="card-description" style="height:150px;">Tracking Current and Past Hospital Encounters.</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1"  @click="openVideoPopup(3)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">5</span>
                          <img src="@/assets/img/Enhance_Your_Profile.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Enhance Your Profile</h4>
          <p class="card-description"  style="height:150px;">Seamlessly Update Your Hospital Information.</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1"  @click="openVideoPopup(4)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-12">
                            <div class="demo-video-card-container">
                              <div class="demo-video-card p-3">
                                <span class="badge badge-pill badge-primary" style="position: absolute; top: 10px; right: 10px;">6</span>
                          <img src="@/assets/img/Patient_Transaction_Log.jpg" alt="logo" class="appointment_modal_logo"
                              style="width: 80px; height: 80px; border-radius:100%;" />
          <h4 class="card-heading mt-3">Patient Transaction Log</h4>
          <p class="card-description"  style="height:150px;">Recording Receipts for Comprehensive Medical Transactions</p>
          <div class="card-buttons justify-content-center">
            <button class="btn btn-white m-1"  @click="openVideoPopup(5)"><i class="fas fa-globe"></i> Web App</button>
          </div>
        </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="isVideoPopupVisible" class="video-popup">
  <span class="close-popup" @click="closeVideoPopup">&times;</span>
  <iframe :src="currentVideoUrl" width="600" height="380" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Page Content -->
            <layout-footer></layout-footer>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import CommonApi from "@/services/CommonApi";
  import config from "../../../services/CommonApi";
  import { mapState } from "vuex";
  const images = require.context("@/assets/img/patients");
  const doctorimages = require.context("@/assets/img/doctors");
  
  export default {
  
    data() {
      return {
        isVideoPopupVisible: false,
        videoUrls: [
      "https://www.youtube.com/embed/O2SB8dDrE1s",
      "https://www.youtube.com/embed/O2SB8dDrE1s",
      "https://www.youtube.com/embed/O2SB8dDrE1s", 
      "https://www.youtube.com/embed/O2SB8dDrE1s",
      "https://www.youtube.com/embed/O2SB8dDrE1s",
      "https://www.youtube.com/embed/O2SB8dDrE1s",
    ],
      };
    },
    mounted() {
    },
    computed: {
      },
  
    methods: {
        openVideoPopup(index) {
    // Open the video popup with the corresponding video URL
    this.isVideoPopupVisible = true;
    this.currentVideoUrl = this.videoUrls[index];
  },
  closeVideoPopup() {
    // Close the video popup
    this.isVideoPopupVisible = false;
  },
  }
}
  </script>

<style>

.video-popup {
  display: block;
  position: fixed;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.close-popup {
  position: absolute;
  top: 2px;
  right:2px;
  font-size: 30px;
  cursor: pointer;
  color:black;
}

.close-popup:hover {
  color: #ff0000;
}
  .demo-video-card-container {
    display: flex;
    flex-direction: column;
    height: 100%; /* Ensure the container takes full height */
    position: relative;
  }

  .demo-video-card {
    border-radius: 10px;
    background-color: white;
    transition: background-color 0.5s; /* Add a smooth transition effect */
    flex: 1; /* Expand to take remaining space */
  }

  .demo-video-card:hover {
    background-color: #397370;
  }

  .card-buttons {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background-color: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
    transition: background-color 0.5s; /* Add a smooth transition effect */
  }
  .card-buttons button:hover {
    background-color:#66cdaa; /* Change the background color on hover */
    color: white; /* Change the text color on hover */
    transform: scale(1.1); /* Increase the size on hover */
  }

  .demo-video-card-container:hover .card-buttons {
    background-color: rgba(57, 115, 112, 0.8); /* Semi-transparent background on hover */
  }

  .new_btn:hover {
    background-color: #10553e;
  }

  .demo-video-card-container:hover .card-heading,
  .demo-video-card-container:hover .card-description {
    color: white;
  }
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/hospital/OnBoarding.vue